import { cloneDeep } from 'lodash-es';
import * as S from './ExcludeSettings.styled';
import { Buttons } from 'components';
import { DeleteIcon } from 'assets/icons';
import { ChooseCampaigns, ParagraphWithTooltip } from 'components';

const ExcludeCampaigns = ({ value, onChange }) => {
  const clearAll = () => {
    onChange([]);
  };

  const deleteCampaign = (id) => {
    let newCamp = cloneDeep(value);
    newCamp = newCamp.filter((camp) => camp?.cm_campaignid !== id);
    onChange(newCamp);
  };

  return (
    <>
      <S.TextField>
        <S.Title>Exclude Campaigns:</S.Title>
      </S.TextField>
      <S.FieldsWrap>
        <S.ActionField>
          <S.BtnWrap>
            <ChooseCampaigns
              title='Exclude Campaigns'
              setSelectedCampaigns={onChange}
              selectedCampaigns={value}
            />
          </S.BtnWrap>
          {value?.length > 0 && (
            <>
              <S.Line />
              <S.BtnWrapp>
                <Buttons.TertiaryNormal
                  id='categories_clear_all'
                  onClick={clearAll}
                  style={{ marginLeft: '16px' }}
                >
                  Clear All
                </Buttons.TertiaryNormal>
              </S.BtnWrapp>
              <S.Wrap>
                <S.SelectedItem>
                  {value?.map((item) => (
                    <S.Item key={item?.cm_campaignid} height='52px' line>
                      <S.Column>
                        <ParagraphWithTooltip text={item?.cm_name} field='campaigns' />
                        <S.Id>{item?.cm_campaignid}</S.Id>
                      </S.Column>
                      <S.IconWrapp onClick={() => deleteCampaign(item?.cm_campaignid)}>
                        <DeleteIcon />
                      </S.IconWrapp>
                    </S.Item>
                  ))}
                </S.SelectedItem>
              </S.Wrap>
            </>
          )}
        </S.ActionField>
      </S.FieldsWrap>
    </>
  );
};

export default ExcludeCampaigns;
